'use client';

import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import Button from '@mui/material/Button';
import TodayIcon from '@mui/icons-material/Today';
import { filterableRoute } from '@/utils/routes';

const BackToToday = () => {
  const searchParams = useSearchParams();
  const startParam = searchParams.get('start');

  if (!startParam) return null;

  const params: Record<string, string | null> = {};
  searchParams.forEach((v, k) => { params[k] = v; });
  const { filter, type, categoryIds } = params;

  const href = filterableRoute('/calendar', { filter, type, categoryIds });

  return (
    <Button
      component={Link}
      href={href}
      size="small"
      startIcon={<TodayIcon />}
      sx={{ mx: 1, mb: 1 }}
    >
      Jump to today
    </Button>
  );
};

export default BackToToday;
